


export const MANAGE_EMPLOYEE_CYCLES = 'manageEmpolyeeCycle';
export const GET_MANAGE_EMPLOYEE_CYCLES = `${MANAGE_EMPLOYEE_CYCLES}/getManageEmployeeCycleAction`;


